import Routing from "./Routing/route";
import UserContextProvider from "./Context/User/userContextProvider.jsx";

function App() {
  return (
    <UserContextProvider>
      <Routing />
    </UserContextProvider>
  );
}

export default App;
